import * as React from "react";

const ErrorLayout: React.FC = ({ children }) => {
  return <div className="layout layout--error">{children}</div>;
};

export default ErrorLayout;
